// projects/humanresources-payroll/src/assets/i18n/*/hr-pay-payroll-switch.json
export class HrPayPayrollSwitchKey {
    private static readonly keyPrefix = 'hrPayPayrollSwitch';
    public static pageHeader = `${HrPayPayrollSwitchKey.keyPrefix}.pageHeader`;
    public static code = `${HrPayPayrollSwitchKey.keyPrefix}.code`;
    public static employeeType = `${HrPayPayrollSwitchKey.keyPrefix}.employeeType`;
    public static periodSwitch = `${HrPayPayrollSwitchKey.keyPrefix}.periodSwitch`;
}
